import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import app from './modules/app'
import appNavbar from './modules/app-navbar'
import service from './modules/service'

export default createStore({
  modules: {
    app,
    appNavbar,
    service
  },
  plugins: [
    createPersistedState({ // vuex 持久化配置 | 默认存储在localStore上
      key: 'work-portal', // 本地存储名字
      paths: ['service'],
      storage: sessionStorage
    })
  ]
})
